import BaseBarChartWidgetController from './base_bar_chart_widget_controller';
import { PURPLE_400, GREEN_400 } from '../../../shared/colors';

export default class extends BaseBarChartWidgetController {
  getChartConfig(data) {
    const { total_learners, completed_learners } = data;

    return {
      labels: ['', ''],
      values: [total_learners, completed_learners],
      colors: [PURPLE_400, GREEN_400],
    };
  }
}
